import { segmentSlice } from "./segment.reducer";

export const { addSegment } = segmentSlice.actions;
export default segmentSlice.actions;
